/**
 * Mock analytics data sourced from EnergyImpactAIWorks artifacts/eda_v2
 * and MODEL_V2_REPORT (Newcastle United pilot).
 */

export const MATCHDAY_BY_SITE = [
  {
    site: 1,
    name: 'Academy',
    n: 157,
    nonMatch: 747,
    match: 668,
    upliftPct: -10.6,
    dayBefore: 810,
    dayAfter: 737,
  },
  {
    site: 2,
    name: "St James' Park",
    n: 157,
    nonMatch: 15683,
    match: 28348,
    upliftPct: 80.8,
    dayBefore: 15906,
    dayAfter: 17932,
  },
  {
    site: 115,
    name: 'Training Ground',
    n: 157,
    nonMatch: 1813,
    match: 1887,
    upliftPct: 4.1,
    dayBefore: 2246,
    dayAfter: 1968,
  },
  {
    site: 166,
    name: 'Fan Zone',
    n: 66,
    nonMatch: 2022,
    match: 2575,
    upliftPct: 27.4,
    dayBefore: 2127,
    dayAfter: 1989,
  },
  {
    site: 225,
    name: 'Metro Centre',
    n: 28,
    nonMatch: 153,
    match: 138,
    upliftPct: -9.8,
    dayBefore: 144,
    dayAfter: 138,
  },
  {
    site: 261,
    name: 'Media Centre',
    n: 10,
    nonMatch: 58,
    match: 43,
    upliftPct: -26.4,
    dayBefore: 60,
    dayAfter: 71,
  },
]

export const COMPETITION_IMPACT = [
  { competition: 'FA Cup', mean: 30863, median: 29803, count: 7 },
  { competition: 'EFL Cup', mean: 29961, median: 28979, count: 16 },
  { competition: 'UCL', mean: 29520, median: 28472, count: 9 },
  { competition: 'Premier League', mean: 28230, median: 28158, count: 116 },
  { competition: 'Friendly', mean: 23873, median: 24409, count: 9 },
]

export const EVENT_IMPACT = [
  { date: '2021-09-04', eventType: 'rugby', total: 29055, baseline: 13621, ratio: 2.13 },
  { date: '2021-09-05', eventType: 'rugby', total: 30597, baseline: 13621, ratio: 2.25 },
  { date: '2022-07-09', eventType: 'rugby', total: 26758, baseline: 11838, ratio: 2.26 },
  { date: '2023-06-09', eventType: 'concert', total: 23927, baseline: 10898, ratio: 2.2 },
  { date: '2023-06-10', eventType: 'concert', total: 26617, baseline: 11711, ratio: 2.27 },
  { date: '2024-06-03', eventType: 'football_other', total: 25200, baseline: 8968, ratio: 2.81 },
  { date: '2025-06-12', eventType: 'concert', total: 24775, baseline: 11188, ratio: 2.21 },
  { date: '2025-06-14', eventType: 'concert', total: 24985, baseline: 11188, ratio: 2.23 },
  { date: '2025-06-15', eventType: 'concert', total: 28113, baseline: 11769, ratio: 2.39 },
]

export const METER_MATCH_UPLIFT = [
  { meterId: 3, code: '1507061560013', nonMatch: 3956, match: 14042, upliftPct: 255.0 },
  { meterId: 4, code: '1507061560022', nonMatch: 7223, match: 8249, upliftPct: 14.2 },
  { meterId: 5, code: '1592007048005', nonMatch: 4513, match: 6057, upliftPct: 34.2 },
]

export const COVID_VS_NORMAL = [
  { label: 'Normal match day', mean: 28348, median: 28202, count: 157 },
  { label: 'COVID closed doors', mean: 11215, median: 11887, count: 23 },
]

export const FANZONE_MATCH = [
  { label: 'Weekday · no match', mean: 1871, count: 411 },
  { label: 'Weekend · no match', mean: 2227, count: 142 },
  { label: 'Weekday · match', mean: 2417, count: 19 },
  { label: 'Weekend · match', mean: 2594, count: 30 },
]

export const SITE_OVERVIEW = [
  {
    name: "St James' Park",
    type: 'stadium',
    mean: 15568,
    median: 14575,
    p95: 27680,
    cv: 0.44,
    days: 2642,
  },
  {
    name: 'Training Ground',
    type: 'training_ground',
    mean: 1647,
    median: 1377,
    p95: 3405,
    cv: 0.62,
    days: 2640,
  },
  { name: 'Fan Zone', type: 'fan_zone', mean: 2071, median: 2046, p95: 2697, cv: 0.18, days: 786 },
  { name: 'Academy', type: 'academy', mean: 695, median: 671, p95: 1123, cv: 0.36, days: 2641 },
  {
    name: 'Metro Centre',
    type: 'retail_store',
    mean: 151,
    median: 147,
    p95: 200,
    cv: 0.19,
    days: 333,
  },
  {
    name: 'Media Centre',
    type: 'office_media',
    mean: 58,
    median: 58,
    p95: 79,
    cv: 0.36,
    days: 193,
  },
]

/** Monthly seasonality norm (relative to site mean) — SJP + Academy + TG */
export const MONTHLY_SEASONALITY = {
  months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  series: [
    {
      name: "St James' Park",
      data: [1.37, 1.3, 1.12, 0.79, 0.69, 0.63, 0.58, 0.74, 0.96, 1.17, 1.27, 1.38],
    },
    {
      name: 'Academy',
      data: [1.24, 1.18, 1.14, 0.98, 0.83, 0.64, 0.73, 0.79, 0.95, 1.11, 1.3, 1.1],
    },
    {
      name: 'Training Ground',
      data: [1.5, 1.24, 1.13, 1.08, 0.91, 0.72, 0.69, 0.77, 0.82, 0.88, 1.06, 1.19],
    },
    {
      name: 'Fan Zone',
      data: [1.03, 0.99, 0.97, 0.96, 0.97, 0.93, 0.91, 0.98, 0.97, 1.04, 1.11, 1.14],
    },
  ],
}

export const YEARLY_TREND_SJP = [
  { year: '2019', mean: 15865 },
  { year: '2020', mean: 11293 },
  { year: '2021', mean: 13314 },
  { year: '2022', mean: 17165 },
  { year: '2023', mean: 16705 },
  { year: '2024', mean: 16567 },
  { year: '2025', mean: 17745 },
  { year: '2026', mean: 16227 },
]

export const WEATHER_CORR_SJP = [
  { variable: 'Daylight hours', r: -0.771 },
  { variable: 'Solar radiation', r: -0.669 },
  { variable: 'Temp 7d mean', r: -0.591 },
  { variable: 'HDD', r: 0.582 },
  { variable: 'Temperature', r: -0.569 },
]

export const WEATHER_CORR_HEATMAP = [
  // rows: sites, cols: variables — Pearson r for electricity
  {
    name: 'Academy',
    data: [
      { x: 'Temp', y: -0.49 },
      { x: 'HDD', y: 0.49 },
      { x: 'Daylight', y: -0.59 },
      { x: 'Solar', y: -0.52 },
    ],
  },
  {
    name: "St James' Park",
    data: [
      { x: 'Temp', y: -0.57 },
      { x: 'HDD', y: 0.58 },
      { x: 'Daylight', y: -0.77 },
      { x: 'Solar', y: -0.67 },
    ],
  },
  {
    name: 'Training Ground',
    data: [
      { x: 'Temp', y: -0.33 },
      { x: 'HDD', y: 0.34 },
      { x: 'Daylight', y: -0.32 },
      { x: 'Solar', y: -0.24 },
    ],
  },
  {
    name: 'Fan Zone',
    data: [
      { x: 'Temp', y: -0.25 },
      { x: 'HDD', y: 0.26 },
      { x: 'Daylight', y: -0.33 },
      { x: 'Solar', y: -0.29 },
    ],
  },
  {
    name: 'Metro Centre',
    data: [
      { x: 'Temp', y: 0.79 },
      { x: 'HDD', y: -0.77 },
      { x: 'Daylight', y: 0.6 },
      { x: 'Solar', y: 0.55 },
    ],
  },
]

export const ANOMALY_SUMMARY = [
  {
    name: "St James' Park",
    matchDay: 120,
    stadiumEvent: 12,
    dayBefore: 19,
    dayAfter: 10,
    christmas: 8,
    unexplained: 52,
  },
  {
    name: 'Training Ground',
    matchDay: 7,
    stadiumEvent: 1,
    dayBefore: 3,
    dayAfter: 16,
    christmas: 3,
    unexplained: 60,
  },
  {
    name: 'Academy',
    matchDay: 9,
    stadiumEvent: 0,
    dayBefore: 1,
    dayAfter: 11,
    christmas: 0,
    unexplained: 47,
  },
  {
    name: 'Fan Zone',
    matchDay: 24,
    stadiumEvent: 3,
    dayBefore: 0,
    dayAfter: 0,
    christmas: 0,
    unexplained: 12,
  },
]

export const OPERATIONAL_SJP = [
  { label: 'In-season weekday', mean: 18137 },
  { label: 'In-season weekend', mean: 18901 },
  { label: 'In-season Christmas', mean: 22131 },
  { label: 'In-season bank hol.', mean: 15162 },
  { label: 'Off-season weekday', mean: 10278 },
  { label: 'Off-season weekend', mean: 10589 },
]

/** Half-hour profiles by kickoff bucket — sampled every 2 slots (hourly) for chart clarity */
const HH_KO_12 = [
  183, 160, 160, 173, 217, 314, 369, 460, 643, 803, 893, 1073, 1280, 1224, 1072, 855, 716, 540, 476,
  425, 372, 343, 325, 291,
]
const HH_KO_14 = [
  221, 197, 190, 193, 203, 249, 276, 354, 465, 542, 640, 808, 910, 1021, 1246, 1223, 1156, 730, 607,
  511, 422, 373, 349, 320,
]
const HH_KO_17 = [
  180, 167, 165, 178, 189, 212, 218, 252, 297, 354, 424, 486, 541, 670, 818, 930, 1230, 1201, 980,
  755, 608, 579, 412, 361,
]
const HH_KO_19 = [
  288, 267, 267, 266, 270, 311, 321, 356, 356, 360, 358, 412, 452, 509, 554, 654, 980, 1306, 1487,
  1329, 1180, 952, 673, 610,
]
const HH_NO_MATCH = [
  271, 252, 249, 250, 256, 288, 295, 330, 360, 353, 360, 374, 369, 372, 379, 394, 388, 344, 333,
  322, 309, 297, 275, 270,
]

export const HALFHOUR_BY_KICKOFF = {
  categories: Array.from({ length: 24 }, (_, h) => `${h}:00`),
  series: [
    { name: 'KO 12:00–13:59', data: HH_KO_12 },
    { name: 'KO 14:00–16:59', data: HH_KO_14 },
    { name: 'KO 17:00–18:59', data: HH_KO_17 },
    { name: 'KO 19:00+', data: HH_KO_19 },
    { name: 'No match (weekday)', data: HH_NO_MATCH },
  ],
}

/** Heatmap: weekday × hour relative load for SJP (synthetic from profiles) */
export const HEATMAP_WEEKDAY_HOUR = (() => {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  const hours = [0, 3, 6, 9, 12, 15, 18, 21]
  const base = [0.55, 0.5, 0.52, 0.7, 0.95, 1.05, 1.2, 0.85]
  return days.map((day, di) => ({
    name: day,
    data: hours.map((h, hi) => {
      const weekendBoost = di >= 5 ? 1.08 : 1
      const evening = h >= 15 ? 1.15 : 1
      return {
        x: `${h}:00`,
        y: Math.round(base[hi] * weekendBoost * evening * 100),
      }
    }),
  }))
})()

/** Attendance vs match-day kWh scatter (approx. from EDA relationship) */
export const ATTENDANCE_SCATTER: [number, number][] = (() => {
  const pts: [number, number][] = []
  const attendances = [
    0, 0, 0, 5000, 12000, 18000, 25000, 32000, 38000, 42000, 45000, 48000, 50000, 52000, 52200,
  ]
  attendances.forEach((att, i) => {
    const base = att < 1000 ? 11200 : 18000 + att * 0.2
    const noise = ((i * 37) % 17) * 120 - 800
    pts.push([att, Math.round(base + noise)])
  })
  // denser cloud around PL attendance
  for (let i = 0; i < 25; i++) {
    const att = 48000 + ((i * 13) % 40) * 100
    const kwh = 26000 + ((i * 19) % 50) * 80
    pts.push([att, kwh])
  }
  return pts
})()

/** Temp vs non-match daily kWh (negative correlation ~ -0.57) */
export const TEMP_SCATTER: [number, number][] = (() => {
  const pts: [number, number][] = []
  for (let i = 0; i < 60; i++) {
    const temp = -2 + (i / 59) * 24
    const kwh = 22000 - temp * 450 + (((i * 11) % 20) - 10) * 180
    pts.push([Math.round(temp * 10) / 10, Math.round(kwh)])
  }
  return pts
})()

export const FEATURE_IMPORTANCE = [
  { feature: 'naive_seasonal_rel', gainPct: 13.1 },
  { feature: 'last_match_total_rel', gainPct: 11.5 },
  { feature: 'dayofyear', gainPct: 10.5 },
  { feature: 'log_level', gainPct: 7.3 },
  { feature: 'meter_id', gainPct: 6.6 },
  { feature: 'days_to_match', gainPct: 5.6 },
  { feature: 'same_weekday_mean_4w', gainPct: 4.1 },
  { feature: 'w_daylight_hours', gainPct: 4.0 },
  { feature: 'is_match_day', gainPct: 3.8 },
  { feature: 'covid_suspension', gainPct: 3.0 },
  { feature: 'match_attendance', gainPct: 2.1 },
  { feature: 'is_event_day', gainPct: 1.4 },
]

/** Event types as in Settings → Event Types (mock IDs) */
export const SYSTEM_EVENT_TYPES = [
  { id: 11, name: 'Match', start_hour_offset: -3, end_hour_offset: 3 },
  { id: 12, name: 'Concert', start_hour_offset: -4, end_hour_offset: 4 },
  { id: 13, name: 'Rugby', start_hour_offset: -3, end_hour_offset: 3 },
  { id: 14, name: 'Other Football', start_hour_offset: -3, end_hour_offset: 3 },
]

export const SYSTEM_COMPANY = { id: 2, name: 'Newcastle United' }
export const SYSTEM_SITE_SJP = { id: 2, name: "St James' Park" }
